import React, { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import "./Cart.css";
import Header from "../../Components/Header/Header";
import { getCartist, placeOrder, getTransactionDetails, deleteTransaction, updateCart, getWishist, getcartwishlistcount, generateexcel, importexcel, clearcart, updatecartMulti  } from "../../redux/services/productService";
import BottomNavigation from "../../Components/BottomMenu/BottomNavigation";
import Checkout from "../Checkout/Checkout";
import OrderComplete from "../Checkout/Ordercomplete";
import ShopBanner from "../../Components/Banner/Banner";
import banner1 from "../../assets/images/banner1.png"
import SearchHeader from "../../Components/Header/SearchHeader";
import HeaderDummy from "../../Components/Header/HeaderDummy";
import Swal from "sweetalert2";
import { FileSpreadsheet, Trash2 , UploadCloud } from "lucide-react";
import Tooltip from "@mui/material/Tooltip";

const Cart = () => {
     const navigate = useNavigate();
     const location = useLocation();
   const [cartItems, setCartItems] = useState([]);
   const [originalCartItems, setOriginalCartItems] = useState([]);
   const [hasChanges, setHasChanges] = useState(false);
   const [couponCode, setCouponCode] = useState("");
   const [cartCount, setCartCount] = useState("");
  const [step, setStep] = useState(location.state?.step || "cart"); // cart | checkout | orderComplete
   const [transactionDetails, setTransactionDetails] = useState([]); // store API responses
   const [orderResp, setOrderResp] = useState(null); // store API responses
   const [wishlist, setWishlist] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [recallCart, setrecallCart] = useState(false)
  const [cartTrigger, setCartTrigger] = useState(0);
    const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);
    const [cartwishlistCount, setCartwishlistCount] = useState({CartCount:0,WishlistCount:0,CartAmount:0});
   const [typingTimeout, setTypingTimeout] = useState(null);
  
  
    useEffect(() => {
    const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener('resize', handleResize);

  return () => window.removeEventListener('resize', handleResize);
}, []);


  // Handle cart items from navigation state (from slide cart checkout)
  const cartItemsFromState = location.state?.cartItems;
  const [userId, setUserId] = useState(null);
  
     useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
useEffect(() => {
  const storedData = localStorage.getItem('userData');

  if (storedData) {
    let parsedData = JSON.parse(storedData);

    // Check if parsedData is still a string (double stringified case)
    if (typeof parsedData === 'string') {
      parsedData = JSON.parse(parsedData);
    }

    if (parsedData && parsedData[0]?.UserId) {
      setUserId(parsedData[0].UserId);
    }
  }
}, []);

  // Fetch cart data
   useEffect(() => {
     const fetchCart = async () => {
       try {
         const res = await getCartist();
         if(res?.status =="Success"){

            const parsedResult = JSON.parse(res.result);
            

         if (parsedResult?.Data) {
           const mappedItems = parsedResult.Data.map((item, index) => ({
             id: item.TransId || index,
             product:item.Product_Id,
             transId: item.TransId,
             name: item.Product_Name || "Unnamed Product",
             price: item.Rate || 0,
             quantity: item.Quantity || 1,
             image: item.Image,
             StockQty: item.StockQty || 0
           }));

           // If we have cart items from navigation state, use those instead
           const itemsToUse = (cartItemsFromState || mappedItems).map(item => ({
             ...item,
             changed: false // Always reset "changed" when loading from server
           }));
           setCartItems(itemsToUse);
           setOriginalCartItems(itemsToUse);
           // Calculate total quantity for cart count
           const totalQuantity = itemsToUse.reduce((sum, item) => sum + (item.quantity || 1), 0);
           setCartCount(itemsToUse.length);
         }

         }
         else{
          setCartItems([])
          setOriginalCartItems([])
          setCartCount("")
         }
       
       } catch (error) {
         console.error("Error fetching cart:", error);
         setCartItems([])
          setOriginalCartItems([])
          setCartCount("")
       }
     };

     fetchCart();
   }, [cartItemsFromState,recallCart]);

   // fetch wishlist
  //  useEffect(() => {
  //    const fetchWishlist = async () => {
  //      try {
  //        const res = await getWishist();
  //        const parsedResult = JSON.parse(res.result);
  //        setWishlist(parsedResult.Data || []);
  //      } catch (error) {
  //        console.error("Error fetching wishlist:", error);
  //      }
  //    };

  //    fetchWishlist();
  //  }, []);
   useEffect(() => {
         const fetchCartWishlistCount = async () => {
           try {
             const res = await getcartwishlistcount({BE:1});
             if(res?.status =="Success"){
               const parsedResult = JSON.parse(res.result);
               
               setCartwishlistCount(parsedResult[0]);
             }
             else{
               setCartwishlistCount({});
             }
             
           } catch (error) {
             console.error("Error fetching wishlist:", error);
             setCartwishlistCount({});
           }
         };
     
         fetchCartWishlistCount();
       }, [cartTrigger]);

    const handleProceedToCheckout = async () => {
    
        const itemsWithZeroRate = cartItems.filter(item => item.price === 0);
  
  if (itemsWithZeroRate.length > 0) {
    alert("Cannot update cart. Some items have zero price. Please remove them or contact support.");
    return;
  }
    try {
      // Call getTransactionDetails for each cart item
      const response =  await getTransactionDetails(1)
    
      
     if(response?.status =="Success"){
      const data = JSON.parse(response?.result)?.Header
     
      setTransactionDetails(data);
      setStep("checkout");
      
     }
      
      
    } catch (error) {
      console.error("Error fetching transaction details:", error);
   
    }
  };

const updateQuantity = (id, newQuantity) => {
  const item = cartItems.find(i => i.id === id);
  if (!item) return;

  if (newQuantity > item.StockQty) {

    Swal.fire({
          icon: "error",
          //title: "Error",
          text: `Only ${item.StockQty} available in stock.`,
        });
         return; 
  }

  if (newQuantity < 1) return;

  setCartItems((items) =>
  items.map((i) =>
    i.id === id ? { ...i, quantity: newQuantity, changed: true } : i
  )
);
  setHasChanges(true);
};
;

  const handleShopNow = () => {
    navigate("/shop");
  };

const removeItem = async (id) => {
  try {
    const payload = {
      docType: 3,
      be: 1,
      idCollection: [{ id }]
    };

    const res =  await deleteTransaction(payload);
    
    if(res?.status == "Success"){
      setTransactionDetails([])
      setrecallCart(!recallCart)
      setCartTrigger(prev => prev + 1);
    }

    // update UI after success
    // setCartItems((prev) => {
    //   const updatedItems = prev.filter((item) => item.id !== id);
    //   const totalQuantity = updatedItems.reduce((sum, item) => sum + (item.quantity || 1), 0);
    //   setCartCount(updatedItems.length);
    //   return updatedItems;
    // });
    // setOriginalCartItems((prev) => {
    //   const updatedItems = prev.filter((item) => item.id !== id);
    //   return updatedItems;
    // });
  } catch (error) {
    console.error("Failed to delete transaction", error);
  }
};

const handleRemoveSelected = async () => {
  const confirm = await Swal.fire({
    text: `You are about to remove all items.`,
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Remove",
    reverseButtons: true,
    customClass: {
      confirmButton: "next-btn2",
    },
    didOpen: () => {
      const title = document.querySelector(".swal2-title");
      const text = document.querySelector(".swal2-html-container");
      const confirmBtn = document.querySelector(".swal2-confirm.next-btn2");
      const cancelBtn = document.querySelector(".swal2-cancel");

      // Title Style
      if (title) {
        title.style.fontSize = "20px";
        title.style.fontWeight = "600";
      }

      // Text Style
      if (text) {
        text.style.fontSize = "14px";
      }

      // Confirm Button Style (same as Import Excel)
      if (confirmBtn) {
        confirmBtn.style.fontSize = "14px";
        confirmBtn.style.padding = "6px 18px";
        confirmBtn.style.borderRadius = "6px";
        confirmBtn.style.height = "40px";
      }

      // Cancel Button Style
      if (cancelBtn) {
        cancelBtn.style.fontSize = "14px";
        cancelBtn.style.padding = "6px 18px";
        cancelBtn.style.borderRadius = "6px";
        cancelBtn.style.height = "40px";
      }

      // 🔥 Small Screen Adjustment (same logic as import popup)
      if (window.innerWidth < 490) {
        if (confirmBtn) {
          confirmBtn.style.width = "100px";
          confirmBtn.style.fontSize = "13px";
          confirmBtn.style.maxHeight = "40px";
        }
        if (cancelBtn) {
          cancelBtn.style.width = "100px";
          cancelBtn.style.fontSize = "13px";
          cancelBtn.style.maxHeight = "40px";
        }
      }
    }
  });

  if (!confirm.isConfirmed) return;

  try {
    const payload = { BE: 1 };
    const res = await clearcart(payload);

    if (res?.status === "Success") {
      Swal.fire({
        title: "Deleted!",
        text: "All items removed.",
        icon: "success",
        didOpen: () => {
          const title = document.querySelector(".swal2-title");
          const text = document.querySelector(".swal2-html-container");

          if (title) title.style.fontSize = "20px";
          if (text) text.style.fontSize = "14px";
        }
      });

      setTransactionDetails([]);
      setrecallCart(prev => !prev);
      setCartTrigger(prev => prev + 1);
    }
  } catch (error) {
    console.error("Delete failed", error);

    Swal.fire({
      title: "Error",
      text: "Failed to delete items",
      icon: "error",
      didOpen: () => {
        const title = document.querySelector(".swal2-title");
        const text = document.querySelector(".swal2-html-container");

        if (title) title.style.fontSize = "20px";
        if (text) text.style.fontSize = "14px";
      }
    });
  }
};






  const calculateSubtotal = (items) => {
    return items.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
  };

  
  const subtotal = calculateSubtotal(originalCartItems);
  const shipping = 0;
  const vat = subtotal * 0.05;
  const total = subtotal + shipping + vat;

  const handlePlaceOrder = async (billingInfo) => {
  try {
    const payload = {
      transId: 0,
      date: new Date().toISOString().split("T")[0],
      country: 1,
      be: 1,
      customer: 0,
      deliveryAddress: `${billingInfo.address1}, ${billingInfo.address2}, ${billingInfo.city}, ${billingInfo.state}`,
      eventName: "chk",
      remarks: billingInfo.notes,
      discountType: 0,
      payTerms: billingInfo.payTerms || 1,
      discountCouponRef: null,
      discountRef: null,
      sampleRequestBy: 0,
      deliveryTerms: null,
      deliveryDate: null,
      body: transactionDetails.map((item) => ({
          transId: item.TransId,
          product: item.Product,
          qty: item.Quantity,
          headerId: 0,
          voucherType: 1,
          rate: item.Rate,
          unit: item.Unit,
          vat: 5,
          addcharges: item.AddCharges ?? 0,
          discount: item.Discount ?? 0,
          discountAmt: item.DiscountAmt ?? 0,
          discountRemarks: item.DiscountRemarks ?? null,
          remarks: item.Remarks ?? null,
        }))
    };

    const res = await placeOrder(payload);
    if(res?.status =="Success"){
      setOrderResp(res.result);
    // Clear cart and checkout data after successful order placement
    setCartItems([]);
    setOriginalCartItems([]);
    setTransactionDetails([]);
    setCouponCode("");
    setHasChanges(false);
    setCartCount(0);
    setStep("orderComplete");
    setCartTrigger(prev => prev + 1);
    }
    
  } catch (error) {
    console.error("Error placing order:", error);
    
  }
};
const handleUpdateCart = async () => {

   const changedItems = cartItems.filter(item => item.changed);

  if (changedItems.length === 0) {
    // No actual changes; nothing to update
    return;
  }
  for (const item of changedItems) {
    if (item.quantity > item.StockQty) {
   
       Swal.fire({
          icon: "error",
          //title: "Error",
          text: `Quantity of ${item.name} exceeds available stock (${item.StockQty}).`,
        });
         return; // stop update
    }
    if (item.quantity < 1 || isNaN(item.quantity)) {
     
       Swal.fire({
          icon: "error",
          //title: "Error",
          text: `Invalid quantity for ${item.name}.`,
        });
         return; // stop update
    }
  }
  try {
     const payload = {
    be: 1, // or whatever is correct for your API
    details: changedItems.map(item => ({
      TransId: item.transId || 0,
      Qty: Number(item.quantity)
    }))
  };
  const res = await updatecartMulti(payload); 
    // setOriginalCartItems(cartItems);
    setHasChanges(false);
    setrecallCart(!recallCart)
 
  } catch (error) {
    console.error("Failed to update cart:", error);
    
  }
  finally{
    setTransactionDetails([])
    setCartTrigger(prev => prev + 1);
  }
};
const handleQuantityTyping = (id, value) => {
  // Allow empty while typing
  if (value === "") {
     setCartItems(items =>
    items.map(item =>
      item.id === id ? { ...item, quantity: "", changed: true } : item
    )
  );
    setHasChanges(true);
    return;
  }

  // Block non-numeric
  if (!/^[0-9]+$/.test(value)) return;

  // Remove leading zero: "012" → "12"
  const cleaned = value.replace(/^0+/, '') || "0";

   setCartItems(items =>
      items.map(item =>
        item.id === id ? { ...item, quantity: cleaned, changed: true } : item
      )
    );

  setHasChanges(true);
};

const handleExportExcel = async () => {
  try {
    const response = await generateexcel({BE:1}); // API returning file blob
    if(response.status =="Success"){
     const fileUrl = JSON.parse(response.result).replace(/\\/g, "/"); // fix slashes

      const a = document.createElement("a");
      a.href = fileUrl;
      a.target = "_blank"; // <-- OPEN IN NEW TAB
      a.download = ""; // let server filename be used
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Swal.fire("Success", "Excel exported successfully!", "success");

    }
    
  } catch (error) {
    Swal.fire("Error", "Failed to export Excel", "error");
    console.error(error);
  }
};

const handleImportExcel = async () => {
  const { value: file } = await Swal.fire({
    title: "Item Import",
    html: `
      <input type="file" id="excelFile" accept=".xlsx,.xls" class="excel-upload-input">
    `,
    confirmButtonText: "Upload",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    reverseButtons: true,
    customClass: {
      confirmButton: "next-btn2", // your custom button style
    },
    didOpen: () => {
      // Apply inline styles to input
      const input = document.getElementById("excelFile");
      if (input) {
        input.style.maxWidth = "230px";
        input.style.width = "230px";
        input.style.height = "35px";
        input.style.padding = "6px";
        input.style.border = "1px solid #ccc";
        input.style.borderRadius = "6px";
        input.style.fontSize = "14px";
      }
      const titleEl = document.querySelector('.swal2-title');
  if (titleEl) {
    titleEl.style.fontSize = '20px';  // change size here
    titleEl.style.fontWeight = '600';
  }
    const confirmBtn = document.querySelector('.swal2-confirm.next-btn2');


/* For smaller screens */
if (window.innerWidth < 490) {
  if (confirmBtn) {
    confirmBtn.style.width = "100px"; // reduce width
    confirmBtn.style.fontSize = "13px";
    confirmBtn.style.maxHeight  = "40px"
  }
}
    },
    preConfirm: () => {
      const input = document.getElementById("excelFile");
      if (!input.files.length) {
        Swal.showValidationMessage("Please select an Excel file");
        return false;
      }
      return input.files[0];
    },
  });

  if (file) {
    const formData = new FormData();
    formData.append("fileContent", file);

    try {
      const res = await importexcel(formData);
      if (res?.status == "Success" && res?.result == "1") {
        Swal.fire("Success", "Excel imported successfully!", "success");
        setrecallCart(!recallCart)
        setCartTrigger(prev => prev + 1);
      }
      
    } catch (e) {
      if(e?.response?.data?.status =="Failure"){
        Swal.fire("", e?.response?.data?.message, "error");
      }
      else{
        Swal.fire("", "Failed to import file", "error");
      }
      
    }
  }
};



  if (step === "cart" && cartItems.length === 0) {
    return (
      <div className="cart-page empty-cart">
       {isLowEndDevices ? (
  <>

      <Header />
       <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={0}
        otherScreens={true}
         />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={0}
        otherScreens={true}
         />
    <Header />
  </>
)} 
        <ShopBanner
          header=""
          badgeText="Cart Details"
          subheader=""
          backgroundImage={banner1}
          height="60px"
        />
        <div className="breadcrumb">
          <span
            className={`breadcrumb-item ${step === "cart" ? "active" : ""}`}
            onClick={() => {setStep("cart");setOrderResp(null)}}
          >
            SHOPPING CART
          </span>
          <span className="breadcrumb-arrow">→</span>
          <span
            className={`breadcrumb-item ${step === "checkout" ? "active" : ""}`}
            onClick={() => {
              if (!transactionDetails || transactionDetails.length === 0) return;
              setStep("checkout");
            }}
          >
            CHECKOUT
          </span>
          <span className="breadcrumb-arrow">→</span>
          <span
            className={`breadcrumb-item ${
              step === "orderComplete" ? "active" : ""
            }`}
             onClick={() => {
              if (!orderResp || isNaN(Number(orderResp)) || Number(orderResp) <= 0) return;
              setStep("orderComplete")
            }}
          >
            ORDER COMPLETE
          </span>
        </div>
         {step === "cart" && (
          <div style={{ display: "flex", gap: "10px", alignItems: "center",marginBottom:"4px",width:"98%",margin:"auto" }}>

    {/* EXPORT EXCEL */}
 <Tooltip title="Export Excel" arrow>
  <button className="icon-btn" onClick={handleExportExcel}>
    <FileSpreadsheet size={35} stroke="#ff5722" />
  </button>
</Tooltip>

<Tooltip title="Import Excel" arrow>
<button className="icon-btn" onClick={handleImportExcel}>
  <UploadCloud size={35} stroke="#ff5722" />
</button>
</Tooltip>


    

  </div>
         )}

        <div className="empty-cart-content">
          <h2>Your cart is currently empty 🛒</h2>
          <p>Looks like you haven’t added any products yet.</p>
          <button className="shop-now-btn2" onClick={handleShopNow}>
            🛍️ Shop Now
          </button>
        </div>

        <BottomNavigation
          cartCount={cartwishlistCount?.CartCount}
          wishlistCount={cartwishlistCount?.WishlistCount}
          cartItems={cartItems}
          onCartUpdate={() => setCartTrigger(prev => prev + 1)}

        />
      </div>
    );
  }

  const handleProductView = (product) => {
    const updatedProductStructure = {...product,Id:product?.product}//set Id as product id
    navigate('/view', { state: { product:updatedProductStructure, from: 'cart' } });
  };


  return (
    <div className="cart-page" style={{paddingBottom:"50px"}}>
       {isLowEndDevices ? (
  <>

      <Header />
       <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={0}
        otherScreens={true}
         />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={0}
        otherScreens={true}
         />
    <Header />
  </>
)}   
            <ShopBanner
              header=""
              badgeText="Cart Details"
              subheader=""
              backgroundImage={banner1}
              height="60px"
            />
      <div className="cart-container">

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <span
            className={`breadcrumb-item ${step === "cart" ? "active" : ""}`}
            onClick={() => {setStep("cart");setOrderResp(null)}}
          >
            SHOPPING CART
          </span>
          <span className="breadcrumb-arrow">→</span>
          <span
            className={`breadcrumb-item ${step === "checkout" ? "active" : ""}`}
            onClick={() => {
              if (!transactionDetails || transactionDetails.length === 0) return;
              setStep("checkout");
            }}
          >
            CHECKOUT
          </span>
          <span className="breadcrumb-arrow">→</span>
          <span
  className={`breadcrumb-item ${
    step === "orderComplete" ? "active" : ""
  }`}
  onClick={() => {
              if (!orderResp || isNaN(Number(orderResp)) || Number(orderResp) <= 0) return;
              setStep("orderComplete")
            }}
  style={{
    fontWeight: step === "orderComplete" ? "bold" : "normal",
    color: step === "orderComplete" ? "#161616ff" : "#666", // black if active, gray if inactive
    cursor: "pointer",
  }}
>
  ORDER COMPLETE
</span>

        </div>
        {step === "cart" && (
         <div style={{ display: "flex", gap: "10px", alignItems: "center",marginBottom:"4px"}}>

    {/* EXPORT EXCEL */}
    <Tooltip title="Export Excel" arrow>
   <button className="icon-btn" onClick={handleExportExcel}>
  <FileSpreadsheet size={35} stroke="#ff5722" />  {/* Excel Green */}
</button>
</Tooltip>

<Tooltip title="Import Excel" arrow>
<button className="icon-btn" onClick={handleImportExcel}>
  <UploadCloud size={35} stroke="#ff5722" />
</button>
</Tooltip>
<Tooltip title="Clear Cart" arrow>
<button className="icon-btn" onClick={handleRemoveSelected}>
  <Trash2 size={35} stroke="#ff5722" />
</button>
</Tooltip>



    

  </div>
        )}

        {/* Step Views */}
        {step === "cart" && (
          <div className="cart-content">
            <div className="cart-main">
              {/* Cart Table */}
              <div className="cart-table">
                <div className="table-header">
                  <div className="col-product" style={{marginLeft:"50px"}}>{isMobile ? "" :"PRODUCT"}</div>
                  <div className="col-price">{isMobile ? "" : "PRICE"}</div>
                  <div className="col-quantity">{isMobile ? "" :"QUANTITY"}</div>
                  <div className="col-subtotal">{isMobile ? "" : "SUBTOTAL"}</div>
                </div>
                <div className="cart-table-body">
                {cartItems.map((item) => (
                  <div key={item.id} className="table-row-cart">
                    <div className="col-product">
                      <button
                        className="remove-btn-cart"
                        onClick={() => removeItem(item.id)}
                      >
                        ✕
                      </button>
                      <img
                        src={item.image}
                        alt={item.name}
                        className="cart-image-main"
                        onClick={()=>handleProductView(item)}
                        loading="lazy"
                      />
                      <span className="product-name2" onClick={()=>handleProductView(item)}>{item.name}</span>
                    </div>
                    <div className="col-price">
                      {item?.price?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
                    </div>
                    <div className="col-quantity">
                      <div style={{display:"flex",flexDirection:"column",}}>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px', textAlign: 'left' }}>
                        Available: {new Intl.NumberFormat("en-US").format(item.StockQty)}
                      </div>
                      <div className="quantity-controls-cart">
                        <button
                          className="qty-btn"
                          onClick={() => updateQuantity(item.id, Number(item.quantity) - 1)}
                        >
                          −
                        </button>
                          <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            className="qty-input"
                            value={item.quantity}
                            onChange={(e) => handleQuantityTyping(item.id, e.target.value)}
                          />

                        <button
                          className="qty-btn"
                          onClick={() => updateQuantity(item.id, Number(item.quantity) + 1)}
                          disabled={item.quantity >= item.StockQty}
                        >
                          +
                        </button>
                      </div>
                      </div>
                    </div>
                    <div className="col-subtotal">
                      {(item.price * item.quantity).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
                    </div>
                  </div>
                ))}
                </div>
              </div>

              {/* Coupon and Update Cart */}
              <div className="cart-actions">
                <div className="coupon-section">
                  {/* <input
                    type="text"
                    placeholder="Coupon code"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    className="coupon-input"
                  />
                  <button className="apply-coupon-btn">APPLY COUPON</button> */}
                </div>
                <button className="update-cart-btn" onClick={handleUpdateCart} disabled={!hasChanges}>UPDATE CART</button>
              </div>
            </div>

            {/* Cart Totals */}
            <div className="cart-sidebar">
              <div className="cart-totals">
                <h3 className="totals-title">CART TOTALS</h3>

                <div className="totals-row">
                  <span className="totals-label">Subtotal</span>
                  <span className="totals-value">
                    {subtotal.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
                  </span>
                </div>

                <div className="totals-row">
                  <span className="totals-label">Shipping</span>
                  <div className="shipping-info">
                    <span className="free-shipping">Free shipping</span>
                    <small className="shipping-note">
                      Shipping options will be updated during checkout.
                    </small>
                  </div>
                </div>

                <div className="totals-row">
                  <span className="totals-label">VAT</span>
                  <span className="totals-value">{vat.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED</span>
                </div>

                <div className="totals-row total-row">
                  <span className="totals-label">Total</span>
                  <span className="totals-value total-amount">
                    {total.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED
                  </span>
                </div>

                <button
                  className="proceed-checkout-btn"
                  onClick={handleProceedToCheckout}
                >
                  PROCEED TO CHECKOUT
                </button> 
              </div>
            </div>
          </div>
        )}

        {step === "checkout" && (
          <Checkout
            onPlaceOrder={handlePlaceOrder}
            details={transactionDetails}
            goToCart={() => setStep("cart")}
          />
        )}

        {step === "orderComplete" && <OrderComplete orderId={orderResp}/>}
      </div>

      <BottomNavigation
          cartCount={cartwishlistCount?.CartCount}
          wishlistCount={cartwishlistCount?.WishlistCount}
          cartItems={cartItems}
          onCartUpdate={() => setCartTrigger(prev => prev + 1)}

        />
    </div>
  );
};

export default Cart;
